import type React from 'react'
import { isNativePlatform } from '../../../utils/appLifecycle'
import { featureFlag } from '../../../utils/featureFlags'

export type OrbitSlice = {
  id: string
  label: string
  icon: React.FC<{ className?: string }>
  onFire: () => void | Promise<void>
  disabled?: boolean
  disabledReason?: string
}
export type OrbitTarget = string
export type OrbitPageDescriptor = {
  page: string
  centerLabel: string
  contextSlices: () => OrbitSlice[]
  targets?: Partial<Record<OrbitTarget, (node: HTMLElement) => OrbitSlice[]>>
  onCreate?: () => void | Promise<void>
}
export type OrbitOpenState = {
  x: number
  y: number
  slices: OrbitSlice[]
  globalCount: number
  centerLabel: string
  page: string
}
export const orbitIsEnabled = () => !isNativePlatform() && featureFlag('ff_orbit')
